/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Guidevideo_Delete_Confirm1Inputs */

const vi_guidevideo_delete_confirm1 = /** @type {(inputs: Guidevideo_Delete_Confirm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá "${i?.title}" khỏi danh sách hướng dẫn? File video vẫn còn trong Thư viện ảnh.`)
};

/**

* @param {Guidevideo_Delete_Confirm1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_delete_confirm1 = /** @type {((inputs: Guidevideo_Delete_Confirm1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Delete_Confirm1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_delete_confirm1(inputs)
});
export { guidevideo_delete_confirm1 as "guideVideo_delete_confirm" }